import { render, staticRenderFns } from "./cutmoneyLog.vue?vue&type=template&id=506b970d&scoped=true"
import script from "./cutmoneyLog.vue?vue&type=script&lang=js"
export * from "./cutmoneyLog.vue?vue&type=script&lang=js"
import style0 from "./cutmoneyLog.vue?vue&type=style&index=0&id=506b970d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506b970d",
  null
  
)

export default component.exports